import { render, staticRenderFns } from "./ShowBlog.vue?vue&type=template&id=55c9ced6&scoped=true&"
import script from "./ShowBlog.vue?vue&type=script&lang=js&"
export * from "./ShowBlog.vue?vue&type=script&lang=js&"
import style0 from "./ShowBlog.vue?vue&type=style&index=0&id=55c9ced6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c9ced6",
  null
  
)

export default component.exports